import { anchorLink } from "../include/module";
import { toggleMenu } from "../include/module";
import { preImage } from "../include/module";
import { paraNormal } from "../include/module";





(() => {

  anchorLink();
  toggleMenu();
  preImage();
  paraNormal();

})();



// WEBPACK FOOTER //
// ./src/assets/js/common/script.js